export default __webpack_public_path__ + "static/low-complexity-4f1e0924ab0e23ba5829458654212c15.png";